import styled from 'styled-components';
import colors from '@theme/colors';

export default styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 20px 5px 15px;
  border-radius: 4px;
  border: solid 2px ${colors.GOLD};
  > *:not(:first-child) {
    margin-left: 20px;
  }
`;

export const Label = styled.div`
  text-align: center;
  font-size: 14px;
  display: inline-block;
  margin-right: 5px;
`;

export const DivInline = styled.div`
  display: flex;
  align-items: center;
`;

export const checkBoxStyle = {
  width: '30px',
};



// WEBPACK FOOTER //
// ./components/atoms/FormBox.js